import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { environment } from 'src/environments/environment';
import { AuthService } from '../core/auth';

@Injectable({
  providedIn: 'root'
})
export class SignalrService {

  hubUrl = environment.apiUrl.substring(0, environment.apiUrl.lastIndexOf('/'));
  constructor(
    private authService: AuthService) { }

  private hubConnectionTimeExpires: signalR.HubConnection;
  private hubConnectionRefreshToken: signalR.HubConnection;

  public startTimeExpiresConnection = () => {
    this.hubConnectionTimeExpires = new signalR.HubConnectionBuilder()
                            .withUrl(`${this.hubUrl}/time-expires`)
                            .build();
    this.hubConnectionTimeExpires
      .start()
      .then(() => console.log('Time expires connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }

  public startRefreshTokenConnection = () => {
    this.hubConnectionRefreshToken = new signalR.HubConnectionBuilder()
                            .withUrl(`${this.hubUrl}/refresh-token`)
                            .build();
    this.hubConnectionRefreshToken
      .start()
      .then(() => console.log('Refresh token connection started'))
      .catch(err => console.log('Error while starting connection: ' + err));
  }
    
  public addTimeExpiresDataListener = () => {
    this.hubConnectionTimeExpires.on('SendTimeExpires', (data) => {
      var expires = setTimeout(() => {
        this.authService.logout();
      }, data * 60 * 1000);
    });
  }

  public addRefreshTokenDataListener = () => {
    this.hubConnectionRefreshToken.on('SendJwt', (data) => {
      
    });
  }
}
